import React from "react";
import SiteLayout from "../components/SiteLayout";
import Hero from "../components/sections/Hero";
import TrustMarquee from "../components/sections/TrustMarquee";
import StatsBar from "../components/sections/StatsBar";
import ServicesGrid from "../components/sections/ServicesGrid";
import HowItWorks from "../components/sections/HowItWorks";
import Testimonials from "../components/sections/Testimonials";
import CTASection from "../components/sections/CTASection";

export default function Home() {
  return (
    <SiteLayout>
      <Hero />
      <TrustMarquee />
      <StatsBar />
      <ServicesGrid />
      <HowItWorks />
      <Testimonials />
      <CTASection />
    </SiteLayout>
  );
}
